import { ITargetRect } from "./types"

export const getTargetRect = (ref: React.RefObject<any>): ITargetRect => {
  if (!ref.current) {
    return {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: 0,
      height: 0,
    }
  }

  const rect = ref.current.getBoundingClientRect()

  return {
    left: rect.left,
    top: rect.top,
    right: rect.right <= window.innerWidth ? rect.right : window.innerWidth,
    bottom: rect.bottom,
    width: rect.width <= window.innerWidth ? rect.width : window.innerWidth,
    height: rect.height,
  }
}
